// removed by extract-text-webpack-plugin
module.exports = {"root":"_35Oq-ZDeO9wiWfuowqlujI","type-success":"_9zRwgMP8Ph39FpQOgFMLg","type-error":"_1OEU_tbyQOG2QCNBf2u_AE","type-warning":"_2IG0-qeztc6rLr4FoADKB9","type-weak":"_2lPZR4omSjiy8e812IROQ8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/badge.scss
// module id = 1276
// module chunks = 0